<div class="total-match-score">
    <div class="team">
        @if(teamProfileImageSide1) {
            <ion-avatar slot="start">
              <img style="width: auto" [src]="teamProfileImageSide1" />
            </ion-avatar>
        } @else if (teamLogoSide1) {
            <ion-thumbnail slot="start">
              <img style="width: auto" [src]="teamLogoSide1" />
            </ion-thumbnail>
        } @else if (tie?.sides[0]?.team?.abbreviation) {
            <span class="team-name" [ngStyle]="{ backgroundColor: side1Color }"
              >{{ tie?.sides[0]?.team?.abbreviation.slice(0, 1) }}
            </span>
        }
        <div class="point-score {{themeService?.isDarkMode ? 'dark' : 'light'}}">
            {{matchTotalScore?.side1Score ? matchTotalScore?.side1Score : pointScoreSide1}}
        </div>
    </div>
    <div class="team"> 
        @if(teamProfileImageSide2) {
            <ion-avatar slot="start">
              <img style="width: auto" [src]="teamProfileImageSide2" />
            </ion-avatar>
        } @else if (teamLogoSide2) {
            <ion-thumbnail slot="start">
              <img style="width: auto" [src]="teamLogoSide2" />
            </ion-thumbnail>
        } @else if (tie?.sides[1]?.team?.abbreviation) {
            <span class="team-name" [ngStyle]="{ backgroundColor: side2Color }"
              >{{ tie?.sides[1]?.team?.abbreviation.slice(0, 1) }}
            </span>
        }
        <div class="point-score {{themeService?.isDarkMode ? 'dark' : 'light'}}">
            {{matchTotalScore?.side2Score ?matchTotalScore?.side2Score : pointScoreSide2}}
        </div>
    </div>
</div>